import { Outlet, createRootRoute } from "@tanstack/react-router";

// The shell wrapper shared by every page. Each route renders its own masthead
// (catalog vs player variants differ), so the root only owns the .sheet frame.
function RootLayout() {
  return (
    <div className="sheet">
      <Outlet />
    </div>
  );
}

export const Route = createRootRoute({ component: RootLayout });
